'use client';

import React from 'react';
import { Box } from '@skin-seoul/design-system';
import { useLoyaltyService, useUser } from '@skin-seoul/service';
import { LoyaltyBannerDesktop } from './LoyaltyBanner.Desktop';
import { LoyaltyBannerMobile } from './LoyaltyBanner.Mobile';
import { LoyaltyBannerSkeletonDesktop } from './LoyaltyBannerSkeleton.Desktop';
import { LoyaltyBannerSkeletonMobile } from './LoyaltyBannerSkeleton.Mobile';
import { LoyaltySignUpBannerDesktop } from './LoyaltySignUpBanner.Desktop';
import { LoyaltySignUpBannerMobile } from './LoyaltySignUpBanner.Mobile';
interface LoyaltyBannerContainerProps {
  memberSince?: string;
}
export const LoyaltyBannerContainer = ({
  memberSince
}: LoyaltyBannerContainerProps) => {
  const {
    user,
    isAuthenticated,
    isLoading: isUserLoading
  } = useUser();
  const {
    useGetCustomerBalance
  } = useLoyaltyService();
  const {
    data: balanceData,
    isLoading: isBalanceLoading
  } = useGetCustomerBalance({
    customerId: String(user?.id ?? ''),
    enabled: isAuthenticated && Boolean(user?.id)
  });

  // Show skeleton while loading user or balance data
  if (isUserLoading || isBalanceLoading) {
    return <>
        <Box hideFrom="tablet">
          <LoyaltyBannerSkeletonMobile />
        </Box>
        <Box hideBelow="tablet">
          <LoyaltyBannerSkeletonDesktop />
        </Box>
      </>;
  }

  // Show sign up banner if not authenticated or no data
  if (!isAuthenticated || !user?.id || !balanceData) {
    return <>
        <Box hideFrom="tablet">
          <LoyaltySignUpBannerMobile />
        </Box>
        <Box hideBelow="tablet">
          <LoyaltySignUpBannerDesktop />
        </Box>
      </>;
  }

  // Show actual points banner
  return <>
      <Box hideFrom="tablet" data-sentry-element="Box" data-sentry-source-file="LoyaltyBannerContainer.tsx">
        <LoyaltyBannerMobile points={balanceData.availablePoints} data-sentry-element="LoyaltyBannerMobile" data-sentry-source-file="LoyaltyBannerContainer.tsx" />
      </Box>
      <Box hideBelow="tablet" data-sentry-element="Box" data-sentry-source-file="LoyaltyBannerContainer.tsx">
        <LoyaltyBannerDesktop points={balanceData.availablePoints} memberSince={memberSince} data-sentry-element="LoyaltyBannerDesktop" data-sentry-source-file="LoyaltyBannerContainer.tsx" />
      </Box>
    </>;
};